// Shared primitives for wholesale-financing HTML card mocks.

import { Check } from "iconoir-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export function MockFrame({
  children,
  className,
  size = "square",
}: {
  children: ReactNode;
  className?: string;
  size?: "square" | "wide";
}) {
  return (
    <div
      className={cn(
        "border-grey-100 bg-grey-50 relative overflow-hidden rounded-2xl border",
        size === "square" &&
          "h-[326px] w-full lg:aspect-auto lg:h-[371px] lg:w-full xl:w-[371px]",
        size === "wide" &&
          "h-[326px] w-full max-w-[566px] lg:aspect-auto lg:h-[371px] lg:w-[566px]",
        className
      )}
    >
      {children}
    </div>
  );
}

export function BrowserDots({ className }: { className?: string }) {
  return (
    <div className={cn("flex gap-2", className)} aria-hidden>
      <span className="bg-grey-100 size-[15px] rounded-full lg:size-[18px]" />
      <span className="bg-grey-100 size-[15px] rounded-full lg:size-[18px]" />
      <span className="bg-grey-100 size-[15px] rounded-full lg:size-[18px]" />
    </div>
  );
}

export function CheckBadge({
  filled = true,
  className,
}: {
  filled?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "flex size-[22px] shrink-0 items-center justify-center rounded-[11px]",
        filled
          ? "bg-pulse-700"
          : "border-grey-100 border-[1.857px] border-solid bg-transparent",
        className
      )}
    >
      {filled ? (
        <Check className="text-grey-0 size-3.5" strokeWidth={2.5} aria-hidden />
      ) : (
        <Check className="text-grey-200 size-3.5" strokeWidth={2} aria-hidden />
      )}
    </span>
  );
}

export function TwoToneTitle({
  lead,
  emphasis,
  tail,
}: {
  lead: string;
  emphasis: string;
  tail?: string;
}) {
  return (
    <p className="text-[20px] leading-[1.3] tracking-[-0.04em]">
      <span className="text-grey-500">{lead} </span>
      <span className="text-grey-950 font-medium">{emphasis}</span>
      {tail ? <span className="text-grey-500"> {tail}</span> : null}
    </p>
  );
}
